import React, { useState, useEffect } from "react";
import { Box, Stack, Skeleton, Grid } from "@mui/material";
import PhotoCard from "./PhotoCard";

function Photo() {

  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("/api/photos")
    .then(res => {
      return res.json();
    })
    .then(data => {
      setImages(data);
      console.log(data);
    })
  }, []);

  setTimeout(() => {
    setLoading(false);
  }, [1000]);
  
  return (
    <Box p={{ xs: 3, md: 3 }} flex={1}>
      {loading ? (
        <Stack sx={{ marginX: 3 }}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={6} md={8}>
              <Skeleton variant="rounded" height={300} />
            </Grid>
            <Grid item xs={6} md={4}>
              <Skeleton variant="rounded" height={300} />
            </Grid>
            <Grid item xs={6} md={3}>
              <Skeleton variant="rounded" height={200} />
            </Grid>
            <Grid item xs={6} md={9}>
              <Skeleton variant="rounded" height={200} />
            </Grid>
            <Grid item xs={6} md={6}>
              <Skeleton variant="rounded" height={300} />
            </Grid>
            <Grid item xs={6} md={6}>
              <Skeleton variant="rounded" height={300} />
            </Grid>
          </Grid>
        </Stack>
      ) : (
        <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 1, sm: 4, md: 6, lg: 8, xl: 10 }}>
          {
            images.map((images) => (
              <Grid key={images.id} item xs={1} sm={2} md={3} lg={2} xl={2}>
                <PhotoCard images={images}/>
              </Grid>
            ))
          }
        </Grid>
      )}
    </Box>
  );
}

export default Photo;
